<template>
  <div class="intake-review-actions" dir="rtl" @click.stop>
    <span
      v-if="reasonHe"
      class="tag is-light intake-review-chip"
      :title="detail"
      data-test="intake-review-chip"
    >{{ reasonHe }}</span>
    <span v-if="lateLabel" class="tag is-light intake-review-late mr-1" data-test="intake-review-late">{{ lateLabel }}</span>
    <p v-if="doneText" class="is-size-7 has-text-success mt-1" data-test="intake-review-done">{{ doneText }}</p>
    <div v-else class="mt-1">
      <button
        v-if="isDrift"
        class="button is-small is-success is-light"
        :class="{ 'is-loading': busy === 'handled' }"
        :disabled="!!busy"
        data-test="intake-review-handled"
        @click.stop="resolve('handled')"
      >טופל</button>
      <button
        v-if="!isDrift"
        class="button is-small is-success is-light"
        :class="{ 'is-loading': busy === 'continue' }"
        :disabled="!!busy"
        data-test="intake-review-continue"
        @click.stop="resolve('continue')"
      >המשך טיפול</button>
      <button
        v-if="!isDrift"
        class="button is-small is-light"
        :class="{ 'is-loading': busy === 'retry_evaluation' }"
        :disabled="!!busy"
        data-test="intake-review-retry"
        @click.stop="resolve('retry_evaluation')"
      >הערך מחדש</button>
    </div>
    <p v-if="errorText" class="is-size-7 has-text-danger mt-1" data-test="intake-review-error">{{ errorText }}</p>
  </div>
</template>

<script>
// R1.1 - actions for an offer in awaiting_admin_intake ("ממתין לבדיקת יועצת").
// Reject is NOT here on purpose: it stays in the regular status form.
import { formatDate } from '@/custom/helpers/format_date'

const DRIFT_REASON = 'top_firm_domain_drift'

// "continue" lands where the backend decides (result.status) - name it.
const RESOLVED_STATUS_TEXT = {
  awaiting_company: 'ממתין לחברה',
  awaiting_applicant_strong: 'ממתין לאישור מועמד (סטרונג)',
  awaiting_applicant: 'ממתין למועמד'
}

export function resolvedDoneText (action, result) {
  if (action === 'retry_evaluation') return 'נשלח להערכה מחדש'
  if (action === 'handled') return 'סומן כטופל'
  const status = result && result.status
  if (!status) return 'הטיפול נמשך'
  return `הועבר ל${RESOLVED_STATUS_TEXT[status] || status}`
}

export default {
  name: 'IntakeReviewActions',
  props: {
    offer: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      busy: null,
      doneText: '',
      errorText: ''
    }
  },
  computed: {
    review () {
      return (this.offer && this.offer.intake_review) || null
    },
    reasonHe () {
      if (this.review && this.review.reason_he) return this.review.reason_he
      // Feed/bubble serializer sends the label flat as intake_review_reason_he.
      return (this.offer && this.offer.intake_review_reason_he) || ''
    },
    // top_firm_domain_drift: only "handled" applies (continue / retry hidden).
    isDrift () {
      const code = (this.review && this.review.reason) || (this.offer && this.offer.intake_review_reason)
      return code === DRIFT_REASON
    },
    lateLabel () {
      const at = this.review && formatDate(this.review.late_answers_at, 'DD/MM HH:mm')
      return at ? `ענה/תה מאוחר · ${at}` : ''
    },
    detail () {
      return this.review ? (this.review.detail || '') : ''
    },
    offerId () {
      return this.offer.id != null ? this.offer.id : this.offer.resource_id
    }
  },
  methods: {
    async resolve (action) {
      if (this.busy) return
      this.busy = action
      this.errorText = ''
      try {
        const result = await this.$network_utils.resolveIntakeReview({ offer_id: this.offerId, action })
        this.doneText = resolvedDoneText(action, result)
        this.$emit('resolved', { action, result, status: (result && result.status) || null })
      } catch (e) {
        this.errorText = this.errorMessage(e)
      } finally {
        this.busy = null
      }
    },
    errorMessage (e) {
      const res = e && e.response
      const code = res && res.data && res.data.error
      if (res && res.status === 422 && code === 'no_candidate_yes') return 'אין אישור מועמד'
      if (res && res.status === 409) return 'ההצעה כבר לא ממתינה לבדיקה - רעננו את הדף'
      return 'הפעולה נכשלה - נסו שוב'
    }
  }
}
</script>

<style scoped>
.intake-review-actions { margin-top: 4px; }
.intake-review-chip { background-color: #f3e8ff; color: #6b21a8; max-width: 260px; white-space: normal; height: auto; }
.intake-review-late { background-color: #fff7e6; color: #8a5300; }
.intake-review-actions .button + .button { margin-right: 4px; }
</style>
